import { createTheme } from '@mui/material/styles';

// Buamatog theme colors
export const buamatogColors = {
  // Dark background colors
  darkGrey: '#232323',
  darkerGrey: '#181818',
  mediumGrey: '#313131',
  
  // Golden beer accents
  golden: '#FFD700',
  goldenDark: '#E2B13C',
  goldenLight: '#FFE55C',
  
  // Complementary colors
  white: '#FFFFFF',
  lightGrey: '#CCCCCC',
  textPrimary: '#FFFFFF',
  textSecondary: '#CCCCCC',
};

// Create MUI theme
export const buamatogTheme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: buamatogColors.golden,
      dark: buamatogColors.goldenDark,
      light: buamatogColors.goldenLight,
    },
    secondary: {
      main: buamatogColors.mediumGrey,
    },
    background: {
      default: buamatogColors.darkGrey,
      paper: buamatogColors.darkerGrey,
    },
    text: {
      primary: buamatogColors.textPrimary,
      secondary: buamatogColors.textSecondary,
    },
  },
  typography: {
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
    h4: {
      fontWeight: 600,
    },
    h5: {
      fontWeight: 600,
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: '24px',
          textTransform: 'none',
          fontWeight: 600,
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: '16px',
          backgroundColor: buamatogColors.darkerGrey,
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: buamatogColors.darkerGrey,
        },
      },
    },
  },
});

// Background gradient for login/register pages
export const loginGradient = `linear-gradient(135deg, ${buamatogColors.darkerGrey} 0%, ${buamatogColors.darkGrey} 50%, ${buamatogColors.goldenDark} 100%)`;

// Glassmorphism card styles
export const glassmorphismCard = {
  background: 'rgba(35, 35, 35, 0.8)',
  backdropFilter: 'blur(12px)',
  boxShadow: '0 8px 32px 0 rgba(0, 0, 0, 0.5)',
  borderRadius: '16px',
  border: '1px solid rgba(255, 215, 0, 0.18)',
};

// Page container styles
export const pageContainerStyles = {
  background: buamatogColors.darkGrey,
  color: buamatogColors.textPrimary,
  minHeight: '100vh',
};
